import { WORKSPACE_BILLING_STATUSES, type WorkspaceBillingStatus } from "@runcheetah/shared";

type WorkspaceBillingStatusMeta = {
  label: string;
  className: string;
};

const WORKSPACE_BILLING_STATUS_META: Record<WorkspaceBillingStatus, WorkspaceBillingStatusMeta> = {
  incomplete: {
    label: "Incomplete",
    className: "border-amber-200 bg-amber-50 text-amber-700",
  },
  incomplete_expired: {
    label: "Incomplete expired",
    className: "border-slate-200 bg-slate-50 text-slate-600",
  },
  trialing: {
    label: "Trialing",
    className: "border-blue-200 bg-blue-50 text-blue-700",
  },
  active: {
    label: "Active",
    className: "border-green-200 bg-green-50 text-green-700",
  },
  past_due: {
    label: "Past due",
    className: "border-amber-200 bg-amber-50 text-amber-700",
  },
  canceled: {
    label: "Canceled",
    className: "border-slate-200 bg-slate-50 text-slate-600",
  },
  unpaid: {
    label: "Unpaid",
    className: "border-red-200 bg-red-50 text-red-700",
  },
  paused: {
    label: "Paused",
    className: "border-purple-200 bg-purple-50 text-purple-700",
  },
};

export const WORKSPACE_BILLING_STATUS_OPTIONS = WORKSPACE_BILLING_STATUSES.map((status) => ({
  value: status,
  ...WORKSPACE_BILLING_STATUS_META[status],
}));

export const getWorkspaceBillingStatusMeta = (
  status: WorkspaceBillingStatus,
): WorkspaceBillingStatusMeta => WORKSPACE_BILLING_STATUS_META[status];
